import Redirect from '@/containers/Redirect'
import type { RouteConfig } from 'react-router-config'

const routes: RouteConfig[] = [
  {
    path: '/redirect',
    component: Redirect,
  },
]

export default routes
